export const createProfileLink = (accountId) =>
  `${window.AP._hostOrigin}/wiki/plugins/servlet/ac/com.caelor.confluence.cloud.cosmos/caelor-cosmos-portal?ac.cosmosPage=profile&ac.accountId=${accountId}`;

export const createDynamicProfileLink = (accountId, hasCosmos) =>
  hasCosmos
    ? `${window.AP._hostOrigin}/wiki/plugins/servlet/ac/com.caelor.confluence.cloud.cosmos/caelor-cosmos-portal?ac.cosmosPage=profile&ac.accountId=${accountId}`
    : `${window.AP._hostOrigin}/wiki/people/${accountId}`;
